import { Role } from "@linkfluence/models/role";
import { RadarlyAPI } from "./base";

export class RolesAPI extends RadarlyAPI {
  public async attachUserRole(pid: number, uid: number, role: Role) {
    return await this.post<{ ok: boolean }>(
      `/projects/${pid}/roles/users/${uid}.json?role=${role}`
    );
  }
  public async detachUserRole(pid: number, uid: number) {
    return await this.delete<{ ok: boolean }>(
      `/projects/${pid}/roles/users/${uid}.json`
    );
  }
  public async setUserWorkspaces(
    pid: number,
    uid: number,
    workspaceIds: number[]
  ) {
    return await this.post<{ ok: boolean }>(
      `/projects/${pid}/roles/users/${uid}/dashboards.json`,
      { dashboardIds: workspaceIds }
    );
  }
}
